import React from 'react'
import { Box, Skeleton } from '@mui/material'

export function CampaignListSkeleton(): JSX.Element {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        padding: '32px',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
      }}
    >
      <Box sx={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Header Skeleton */}
        <Box sx={{ marginBottom: '32px' }}>
          <Skeleton
            variant="rectangular"
            width={200}
            height={40}
            sx={{
              borderRadius: '8px',
              bgcolor: 'rgba(255, 255, 255, 0.05)',
              marginBottom: '16px',
            }}
          />
          <Skeleton
            variant="rectangular"
            width={300}
            height={20}
            sx={{
              borderRadius: '4px',
              bgcolor: 'rgba(255, 255, 255, 0.05)',
            }}
          />
        </Box>

        {/* Search Bar Skeleton */}
        <Box sx={{ marginBottom: '24px' }}>
          <Skeleton
            variant="rectangular"
            height={56}
            sx={{
              borderRadius: '12px',
              bgcolor: 'rgba(255, 255, 255, 0.05)',
            }}
          />
        </Box>

        {/* Campaign Cards Skeleton */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              lg: 'repeat(3, 1fr)',
            },
            gap: '24px',
          }}
        >
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <Box
              key={i}
              sx={{
                background: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(10px)',
                borderRadius: '16px',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
              }}
            >
              {/* Title */}
              <Skeleton
                variant="rectangular"
                height={28}
                sx={{
                  borderRadius: '4px',
                  bgcolor: 'rgba(255, 255, 255, 0.1)',
                }}
              />

              {/* Metadata row */}
              <Box sx={{ display: 'flex', gap: '12px' }}>
                <Skeleton
                  variant="rectangular"
                  width={80}
                  height={24}
                  sx={{
                    borderRadius: '12px',
                    bgcolor: 'rgba(255, 255, 255, 0.1)',
                  }}
                />
                <Skeleton
                  variant="rectangular"
                  width={100}
                  height={24}
                  sx={{
                    borderRadius: '12px',
                    bgcolor: 'rgba(255, 255, 255, 0.1)',
                  }}
                />
              </Box>

              {/* Description lines */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <Skeleton
                  variant="rectangular"
                  height={16}
                  sx={{
                    borderRadius: '4px',
                    bgcolor: 'rgba(255, 255, 255, 0.08)',
                  }}
                />
                <Skeleton
                  variant="rectangular"
                  height={16}
                  width="80%"
                  sx={{
                    borderRadius: '4px',
                    bgcolor: 'rgba(255, 255, 255, 0.08)',
                  }}
                />
              </Box>

              {/* Action button */}
              <Skeleton
                variant="rectangular"
                height={40}
                sx={{
                  borderRadius: '8px',
                  bgcolor: 'rgba(102, 126, 234, 0.2)',
                  marginTop: 'auto',
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}